import { faEllipsisVertical } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconButton, ListItemIcon, Menu, MenuItem } from "@mui/material"
import React from "react"
import { IActionButton } from "ui/model"

interface IPageHeaderMobileMenuButtonProps {
  actionButtons: IActionButton[]
}

const ID = "phone-header-menu"

export const PageHeaderMobileMenuButton = React.memo(({ actionButtons }: IPageHeaderMobileMenuButtonProps) => {
  const [refreshIndex, setRefreshIndex] = React.useState(0)
  const [isLoading, setIsLoading] = React.useState(false)
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  if (actionButtons.length === 0) {
    return null
  }
  return (
    <div>
      <IconButton
        aria-controls={open ? ID : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{ width: "2.5rem" }}>
        <FontAwesomeIcon icon={faEllipsisVertical} />
      </IconButton>
      <Menu
        id={ID}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button"
        }}>
        {actionButtons.map((a, index) => (
          <MenuItem
            key={index}
            disabled={a.disabled || isLoading}
            onClick={async () => {
              const result = a.onClick()
              if (result instanceof Promise) {
                setIsLoading(true)
                await result
                setIsLoading(false)
              }
              handleClose()
              setRefreshIndex(refreshIndex + 1)
            }}>
            <ListItemIcon>
              <FontAwesomeIcon icon={a.icon} />
            </ListItemIcon>
            {a.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  )
})
